import { Action, State, StateContext, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { AlertService } from 'src/app/shared/store/alert/alert.service';
import { MappingUtilsService } from 'src/app/services/utils/mapping-utils.service';
import { Zone } from '../models/zone.model';
import { ZoneService } from '../services/zone.service';
import { ZoneActions } from './zone.actions';

export class ZoneStateModel {
  public zones: Zone[];
  public isLoadingZones: boolean;
  public error: string;
}

const defaults = {
  zones: [],
  isLoadingZones: false,
  error: null,
};

@State<ZoneStateModel>({
  name: 'zone',
  defaults,
})
@Injectable()
export class ZoneState {
  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private zoneService: ZoneService,
    public store: Store
  ) {}

  @Action(ZoneActions.GetZones) GetZones(
    ctx: StateContext<ZoneStateModel>,
    {}: ZoneActions.GetZones
  ) {
    return this.zoneService.getZones().subscribe({
      next: (response) =>
        ctx.dispatch(new ZoneActions.GetZonesSuccess(response)),
      error: (error) => ctx.dispatch(new ZoneActions.Error(error)),
    });
  }

  @Action(ZoneActions.GetZonesSuccess) getZonesSuccess(
    ctx: StateContext<ZoneStateModel>,
    { zones }: ZoneActions.GetZonesSuccess
  ) {
    ctx.patchState({
      zones: zones.sort((a, b) => a.description.localeCompare(b.description)),
      isLoadingZones: false,
    });
  }

  @Action(ZoneActions.GetZonesByUserAndExercise) getZonesByUserAndExercise(
    ctx: StateContext<ZoneStateModel>,
    { user, exerciseId }: ZoneActions.GetZonesByUserAndExercise
  ) {
    return this.zoneService
      .getZonesByUserAndExercise(user, exerciseId)
      .subscribe({
        next: (response) =>
          ctx.dispatch(new ZoneActions.GetZonesSuccess(response)),
        error: (error) => ctx.dispatch(new ZoneActions.Error(error)),
      });
  }

  @Action(ZoneActions.Error)
  onErrorOccurred(
    ctx: StateContext<ZoneStateModel>,
    { error }: ZoneActions.Error
  ) {
    ctx.patchState({
      error: error,
      isLoadingZones: false,
    });
    MappingUtilsService.showError(
      this.getTitle(),
      error,
      this.alertService,
      this.localizationService
    );
  }
  private getTitle() {
    return this.localizationService.translate('labels.zone');
  }
}
